export const formatBroadcastEstimatedDuration = (totalSeconds: number): string => {
  if (totalSeconds < 60) {
    return '~1 minute'
  }

  if (totalSeconds > 60 * 60 * 12) {
    return '~12 hours'
  }

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)

  const parts: string[] = []
  if (hours > 0) {
    parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`)
  }
  if (minutes > 0) {
    parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`)
  }

  return parts.length > 0 ? `~${parts.join(' ')}` : '~1 minute'
}
